<template>
    <div>
        <div ref="component2" id="myChart2"></div>
    </div>
</template>

<script>
import request from "@/utils/request.js"
export default {
    data() {
        this.isEchart = ""
        return {
            dataList: [],
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            request({
                url: "/sqyl/admin/activityRecruitment/info/findByServiceObject",
                method: "POST",
                data: {},
            }).then((res) => {
                let aa = res.content
                this.dataList = [
                    {value:aa[1],name:"特困老人"},
                    {value:aa[2],name:"低保老人"},
                    {value:aa[4],name:"优抚对象"},
                    {value:aa[5],name:"失独老人"},
                    {value:aa[6],name:"残疾老人"},
                    {value:aa[7],name:"空巢老人"},
                    {value:aa[8],name:"农村留守老人"},
                ]
                console.log(this.dataList,"this.dataList");
                this.drawLine()
            })
        },
        drawLine() {
            // 基于准备好的dom，初始化echarts实例
            const myChart = this.$echarts.init(
                document.getElementById("myChart2")
            )
            // let dataList = [
            //     {
            //         name:"特困老人",
            //         value:4
            //     },
            //     {
            //         name:"低保老人",
            //         value:6
            //     },
            //     {
            //         name:"优抚对象",
            //         value:8
            //     },
            //     {
            //         name:"失独老人",
            //         value:4
            //     },{
            //         name:"残疾老人",
            //         value:6
            //     },{
            //         name:"农村留守老人",
            //         value:3
            //     },
            // ]
            var option

            option = {
                color: [
                    "#9932CC",
                    "#8B0000",
                    "#E9967A",
                    "#94d6da",
                    "#8FBC8B",
                    "#483D8B",
                    "#2F4F4F",
                    
                ],
                legend: {
                    orient: 'vertical',
                    left: 'right',
                    top:'30%',
                    textStyle:{
                        color:'#ffffff',
                        fontSize: 12,
                    }
                },
                tooltip: {
                    trigger: "item",
                },
                // legend: {
                //     orient: "vertical",
                //     right: "20",
                // },
                series: [
                    {
                        name: "服务统计对象",
                        type: "pie",
                        radius: "40%",
                        center: ["35%", "53%"], 
                        data: this.dataList,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                        label: {
                            normal: {
                                show: true,
                                // formatter: "{c}",
                                align: "center",
                                position: "top",
                                distance: 10,
                                textStyle: {
                                    color: "#fff",
                                    fontSize: 12,
                                },
                            },
                        },
                    },
                ],
            }
            option && myChart.setOption(option)
        },
    },
    beforeDestroy() {
        if (this.isEchart) {
            this.isEchart.clear()
        }
    },
}
</script>

<style lang="less" scoped>
#myChart2 {
    width: 400px;
    height: 28vh;
}
</style>
